import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";

import { FolderIcon, UserIcon } from "@heroicons/react/24/outline";

import WorkspaceMembers from "./WorkspaceMembers";

function WorkspacesTable(props) {
  const { workspaces, onWorkspaceClick, users } = props;

  return (
    <Table>
      <TableHead>
        <TableHeader>Workspace</TableHeader>
        <TableHeader>Members</TableHeader>
        <TableHeader>Actions</TableHeader>
      </TableHead>
      <TableBody>
        {workspaces.map((workspace) => {
          const { name, userAdmin } = workspace;

          const userAdminSet = new Set(userAdmin);

          const workspaceMembers = Array.from(userAdminSet)
            .map((eachUserAdmin: string) => {
              const userAdminProfile = users[eachUserAdmin];
              return userAdminProfile;
            })
            .filter((member) => Boolean(member));

          return (
            <TableRow key={workspace._id}>
              <TableCell>
                <div className="flex gap-x-2 items-center">
                  <FolderIcon className="size-4" />
                  <p className="font-semibold">{name}</p>
                </div>
              </TableCell>
              <TableCell>
                <WorkspaceMembers members={workspaceMembers} />
              </TableCell>
              <TableCell>
                <Button outline onClick={() => onWorkspaceClick(workspace)}>
                  <UserIcon /> Manage Members
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export default WorkspacesTable;
